export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Byte: any;
  Date: any;
  DateTime: any;
  Long: any;
  Short: any;
  TimeSpan: any;
  UUID: any;
};

export type ActivityException = {
  __typename?: 'ActivityException';
  /** The Id of the courier */
  courierId: Scalars['Int'];
  /** The date of the itinerary */
  date: Scalars['DateTime'];
  /** The number of custom itinerary computations */
  noOfCustomItineraryComputations: Scalars['Int'];
  /** The number of default itinerary computations */
  noOfDefaultItineraryComputations: Scalars['Int'];
};

export type ActivityExceptionFilterInput = {
  and?: InputMaybe<Array<ActivityExceptionFilterInput>>;
  courier?: InputMaybe<CourierFilterInput>;
  courierId?: InputMaybe<IntOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  noOfCustomItineraryComputations?: InputMaybe<IntOperationFilterInput>;
  noOfDefaultItineraryComputations?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ActivityExceptionFilterInput>>;
};

/** A segment of a collection. */
export type ActivityExceptionsCollectionSegment = {
  __typename?: 'ActivityExceptionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActivityException>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Agency = {
  __typename?: 'Agency';
  /** The Id of the agency */
  id: Scalars['UUID'];
  /** The latitude of the agency */
  latitude: Scalars['Float'];
  /** The longitude of the agency */
  longitude: Scalars['Float'];
  /** The name of the agency */
  name?: Maybe<Scalars['String']>;
};

export type AgencyCourierVisit = {
  __typename?: 'AgencyCourierVisit';
  /** The number of parcels left in agency */
  parcelsStillInAgency?: Maybe<Scalars['Short']>;
  /** The date of the visit */
  visitDate?: Maybe<Scalars['DateTime']>;
  /** The end time of the visit */
  visitEndTime?: Maybe<Scalars['DateTime']>;
  /** The number of charges during visit */
  visitPickupCharges?: Maybe<Scalars['Short']>;
  /** The visit session number */
  visitSessionNumber?: Maybe<Scalars['Byte']>;
  /** The start time of the visit */
  visitStartTime?: Maybe<Scalars['DateTime']>;
};

export type AgencyFilterInput = {
  agencyZones?: InputMaybe<ListFilterInputTypeOfAgencyZoneFilterInput>;
  and?: InputMaybe<Array<AgencyFilterInput>>;
  courierDesignedItineraryProvider?: InputMaybe<StringOperationFilterInput>;
  couriers?: InputMaybe<ListFilterInputTypeOfCourierFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  defaultItineraryProvider?: InputMaybe<StringOperationFilterInput>;
  etaInterval?: InputMaybe<IntOperationFilterInput>;
  externalId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isVisible?: InputMaybe<BooleanOperationFilterInput>;
  latitude?: InputMaybe<FloatOperationFilterInput>;
  longitude?: InputMaybe<FloatOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  oohRoutes?: InputMaybe<ListFilterInputTypeOfOohRouteFilterInput>;
  or?: InputMaybe<Array<AgencyFilterInput>>;
};

export type AgencySettings = {
  __typename?: 'AgencySettings';
  agencyZones?: Maybe<Array<Maybe<AgencyZone>>>;
  /** The courier designed itinerary provider for the agency */
  courierDesignedItineraryProvider?: Maybe<Scalars['String']>;
  /** The default ETA interval of the agency */
  couriers: Array<Courier>;
  createdAt: Scalars['DateTime'];
  /** The default itinerary provider for the agency */
  defaultItineraryProvider?: Maybe<Scalars['String']>;
  /** The default ETA interval of the agency */
  etaInterval: Scalars['Int'];
  externalId: Scalars['Int'];
  /** The Id of the agency */
  id: Scalars['UUID'];
  isVisible: Scalars['Boolean'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  /** The name of the agency */
  name?: Maybe<Scalars['String']>;
  oohRoutes?: Maybe<Array<Maybe<OohRoute>>>;
};


export type AgencySettingsCouriersArgs = {
  agencyId?: InputMaybe<Scalars['ID']>;
  courierFiltering?: InputMaybe<CourierFiltering>;
  date?: InputMaybe<Scalars['Date']>;
};

export type AgencySettingsMutationInput = {
  agencyId: Scalars['UUID'];
  courierDesignProvider?: InputMaybe<Scalars['String']>;
  defaultProvider?: InputMaybe<Scalars['String']>;
  etaInterval: Scalars['Int'];
};

export type AgencySettingsPayload = {
  __typename?: 'AgencySettingsPayload';
  courierDesignProvider?: Maybe<Scalars['String']>;
  defaultProvider?: Maybe<Scalars['String']>;
  etaInterval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
};

export type AgencyZone = {
  __typename?: 'AgencyZone';
  agency?: Maybe<AgencySettings>;
  agencyId: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  externalZoneId: Scalars['Int'];
  id: Scalars['UUID'];
  zoneCode?: Maybe<Scalars['String']>;
};

export type AgencyZoneFilterInput = {
  agency?: InputMaybe<AgencyFilterInput>;
  agencyId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<AgencyZoneFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  externalZoneId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<AgencyZoneFilterInput>>;
  zoneCode?: InputMaybe<StringOperationFilterInput>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type BreakDefinitionInput = {
  durationSeconds: Scalars['Int'];
  windowEnd?: InputMaybe<Scalars['String']>;
  windowStart?: InputMaybe<Scalars['String']>;
};

export type CapacityPlanBreak = {
  __typename?: 'CapacityPlanBreak';
  /** Length of the break in seconds */
  durationSeconds: Scalars['Int'];
  /** Latest start of the break, HH:mm:ss */
  windowEnd: Scalars['String'];
  /** Earliest start of the break, HH:mm:ss */
  windowStart: Scalars['String'];
};

export type CapacityPlanDeliveriesPage = {
  __typename?: 'CapacityPlanDeliveriesPage';
  items: Array<CapacityPlanDelivery>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  /** Deliveries matching the filter across all pages */
  totalCount: Scalars['Int'];
};

export type CapacityPlanDelivery = {
  __typename?: 'CapacityPlanDelivery';
  /** Recipient address */
  address?: Maybe<Scalars['String']>;
  /** Recipient county */
  county?: Maybe<Scalars['String']>;
  /** The source system's parcel identifier, as the file spelled it */
  deliveryId?: Maybe<Scalars['String']>;
  /** The Planning Depot this row is solved from; null until the Run has been planned into Solves */
  depotIndex?: Maybe<Scalars['Int']>;
  /** Why the row could not be geocoded; never contains address text */
  geocodeError?: Maybe<Scalars['String']>;
  /** NOT_NEEDED, PENDING, GEOCODED, FAILED or MANUAL */
  geocodeStatus: CapacityPlanGeocodeStatus;
  /** Whether the row carried a RecipientPhone. The phone itself is never returned (ADR-0003) */
  hasRecipientPhone: Scalars['Boolean'];
  id: Scalars['Long'];
  /** True when the Address Processing Flow answered an approximated location */
  isApproximated: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /** True when the row is valid, has both coordinates and its point is outside the country's box; such a row is left out of Compute */
  outOfCountry: Scalars['Boolean'];
  /** 1-based row number in the uploaded file, header excluded */
  rowNumber: Scalars['Int'];
  /** Recipient town */
  town?: Maybe<Scalars['String']>;
  /** Null when the row is valid and takes part in the solve */
  validationError?: Maybe<Scalars['String']>;
  /** Recipient village */
  village?: Maybe<Scalars['String']>;
};

export type CapacityPlanDeliveryAddressPayload = {
  __typename?: 'CapacityPlanDeliveryAddressPayload';
  address?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  deliveryId: Scalars['Long'];
  geocodeStatus: CapacityPlanGeocodeStatus;
  runId: Scalars['UUID'];
  town?: Maybe<Scalars['String']>;
  validationError?: Maybe<Scalars['String']>;
  village?: Maybe<Scalars['String']>;
};

export type CapacityPlanDeliveryCoordinatesPayload = {
  __typename?: 'CapacityPlanDeliveryCoordinatesPayload';
  deliveryId: Scalars['Long'];
  geocodeStatus: CapacityPlanGeocodeStatus;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  runId: Scalars['UUID'];
};

/** Which subset of a Run's Deliveries to return */
export enum CapacityPlanDeliveryFilter {
  All = 'ALL',
  Approximated = 'APPROXIMATED',
  FailedGeocode = 'FAILED_GEOCODE',
  Invalid = 'INVALID',
  MissingCoordinates = 'MISSING_COORDINATES',
  OutOfCountry = 'OUT_OF_COUNTRY',
  PendingGeocode = 'PENDING_GEOCODE'
}

export type CapacityPlanDeliveryIssue = {
  __typename?: 'CapacityPlanDeliveryIssue';
  /** Deliveries of the Run in this group */
  count: Scalars['Int'];
  /** INVALID_ROW, FAILED_GEOCODE or APPROXIMATED */
  kind: CapacityPlanDeliveryIssueKind;
  /** Server-generated reason text (ValidationError / GeocodeError). For APPROXIMATED it is the fixed text 'Location approximated'. Never contains address text */
  reason: Scalars['String'];
};

/** The kind of problem a group of Deliveries shares */
export enum CapacityPlanDeliveryIssueKind {
  Approximated = 'APPROXIMATED',
  FailedGeocode = 'FAILED_GEOCODE',
  InvalidRow = 'INVALID_ROW',
  OutOfCountry = 'OUT_OF_COUNTRY'
}

/** The Solves of one Planning Depot with their routes and geometry */
export type CapacityPlanDepotRoutes = {
  __typename?: 'CapacityPlanDepotRoutes';
  /** 1-based Planning Depot label the routes were asked for */
  depotIndex: Scalars['Int'];
  /** One Solve per Cluster of the Planning Depot, in Cluster order */
  solves: Array<CapacityPlanSolve>;
};

export type CapacityPlanDepotSummary = {
  __typename?: 'CapacityPlanDepotSummary';
  /** Agency of this Planning Depot as first spelled in the file; null for Runs created before the Agency column */
  agencyName?: Maybe<Scalars['String']>;
  /** Deliveries solved from this Planning Depot */
  deliveries: Scalars['Int'];
  /** Deliveries per driver, rounded to one decimal */
  deliveriesPerDriver: Scalars['Float'];
  /** 1-based Planning Depot label: the depot is shown as 'Depot {depotIndex}' */
  depotIndex: Scalars['Int'];
  /** Drivers needed for this Planning Depot */
  drivers: Scalars['Int'];
  /** Deliveries of this Planning Depot carried by the Solves that failed: counted in, but not solved */
  failedDeliveries: Scalars['Int'];
  /** Solves of this Planning Depot that failed; retry them to complete the Run */
  failedSolves: Scalars['Int'];
  /** Planning Depot latitude: a logistic location, not a customer address */
  latitude: Scalars['Float'];
  /** Planning Depot longitude: a logistic location, not a customer address */
  longitude: Scalars['Float'];
  /** Recipients at this depot; 0 for older runs */
  recipients: Scalars['Int'];
  /** Routed recipients per driver, rounded to one decimal; 0 for older runs */
  recipientsPerDriver: Scalars['Float'];
  /** Recipients at the stops on routes: unassigned stops and failed solves left out; 0 for older runs */
  routedRecipients: Scalars['Int'];
  /** Solves this Planning Depot was split into: one per Cluster, one when it was not split */
  solves: Scalars['Int'];
  /** Stops the Deliveries were grouped into */
  stops: Scalars['Int'];
  /** Deliveries on the unassigned Stops */
  unassignedDeliveries: Scalars['Int'];
  /** Stops the solver could not fit into the Shift Window and Capacity */
  unassignedStops: Scalars['Int'];
};

export enum CapacityPlanErrorCode {
  DeliveryAddressRefused = 'DELIVERY_ADDRESS_REFUSED',
  DeliveryCoordinatesRefused = 'DELIVERY_COORDINATES_REFUSED',
  DeliveryOutOfCountry = 'DELIVERY_OUT_OF_COUNTRY',
  Forbidden = 'FORBIDDEN',
  GeocodeRequestFailed = 'GEOCODE_REQUEST_FAILED',
  MissingPlanningDepot = 'MISSING_PLANNING_DEPOT',
  NetworkRunRequiresHq = 'NETWORK_RUN_REQUIRES_HQ',
  NothingToGeocode = 'NOTHING_TO_GEOCODE',
  NoFailedSolves = 'NO_FAILED_SOLVES',
  NoValidDeliveries = 'NO_VALID_DELIVERIES',
  RunIsComputing = 'RUN_IS_COMPUTING',
  RunIsQueued = 'RUN_IS_QUEUED',
  RunNotFound = 'RUN_NOT_FOUND',
  RunNotReady = 'RUN_NOT_READY'
}

export enum CapacityPlanGeocodeStatus {
  Failed = 'FAILED',
  Geocoded = 'GEOCODED',
  Manual = 'MANUAL',
  NotNeeded = 'NOT_NEEDED',
  Pending = 'PENDING'
}

export type CapacityPlanGeocoding = {
  __typename?: 'CapacityPlanGeocoding';
  requested: Scalars['Int'];
  run: CapacityPlanRun;
};

export type CapacityPlanRoute = {
  __typename?: 'CapacityPlanRoute';
  /** Deliveries assigned to this route */
  deliveryCount: Scalars['Int'];
  distanceMeters: Scalars['Int'];
  durationSeconds: Scalars['Int'];
  /** Return time at the Planning Depot, HH:mm:ss; null when the solver reported none */
  endTime?: Maybe<Scalars['String']>;
  /** Road geometry as [longitude, latitude] pairs, ready for mapbox */
  geometry: Array<Array<Scalars['Float']>>;
  /** Recipients at the stops on this route, so routes may sum lower than their depot; 0 for older runs */
  recipients: Scalars['Int'];
  serviceSeconds: Scalars['Int'];
  steps: Array<CapacityPlanRouteStep>;
  /** Job steps on the route; start, break and end are not counted */
  stopCount: Scalars['Int'];
  /** Solver vehicle id, used as the route's identity on the map */
  vehicleId: Scalars['Int'];
};

export type CapacityPlanRouteStep = {
  __typename?: 'CapacityPlanRouteStep';
  /** Arrival time in seconds from midnight, the same base as the Shift Window */
  arrivalSeconds: Scalars['Int'];
  /** The file's own DeliveryId for each of those Deliveries, in file order, so the table needs no second query */
  deliveryCodes: Array<Scalars['String']>;
  /** Row ids of the Deliveries grouped into this Stop */
  deliveryIds: Array<Scalars['Long']>;
  latitude?: Maybe<Scalars['Float']>;
  /** Deliveries still on board after this step */
  load: Scalars['Int'];
  longitude?: Maybe<Scalars['Float']>;
  /** Seconds spent at this step */
  serviceSeconds: Scalars['Int'];
  /** The solver Stop this step serves; null for start, break and end */
  stopId?: Maybe<Scalars['Int']>;
  /** start, job, break or end */
  type: Scalars['String'];
};

export type CapacityPlanRun = {
  __typename?: 'CapacityPlanRun';
  /** The Agency the Run belongs to; null on a Network Run, which belongs to the country */
  agencyId?: Maybe<Scalars['UUID']>;
  agencyName?: Maybe<Scalars['String']>;
  /** Geocoded Deliveries whose pin is approximated (street or town level) */
  approximatedGeocodes: Scalars['Int'];
  computedAt?: Maybe<Scalars['DateTime']>;
  /** When the first of the Run's Solves started computing; null while none has */
  computingStartedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  /** Username of the supervisor who uploaded the file */
  createdBy?: Maybe<Scalars['String']>;
  /** One summary row per Planning Depot; empty until the Run is computed. Routes come from capacityPlanRoutes */
  depots: Array<CapacityPlanDepotSummary>;
  /** Drivers needed; null until the Run is computed */
  driverCount?: Maybe<Scalars['Int']>;
  /** Failure message when the Run is Failed */
  error?: Maybe<Scalars['String']>;
  /** Deliveries the Address Processing Flow could not geocode; excluded from the solve */
  failedGeocodes: Scalars['Int'];
  fileName?: Maybe<Scalars['String']>;
  /** When geocoding was last requested for this Run; null until a supervisor asked */
  geocodeRequestedAt?: Maybe<Scalars['DateTime']>;
  /** Deliveries that have coordinates */
  geocodedDeliveries: Scalars['Int'];
  id: Scalars['UUID'];
  /** Rows kept with a ValidationError and excluded from the solve */
  invalidDeliveries: Scalars['Int'];
  /** True when the Run has no Agency: readable and computable by headquarters users only */
  isNetworkRun: Scalars['Boolean'];
  /** Free text naming the Run for humans; defaults to the file name */
  label?: Maybe<Scalars['String']>;
  /** Valid Deliveries still without coordinates; a compute skips them and warns */
  missingCoordinates: Scalars['Int'];
  /** Valid Deliveries whose point is outside the country; a compute leaves them out unless moved inside */
  outOfCountryDeliveries: Scalars['Int'];
  /** Deliveries waiting for the Address Processing Flow */
  pendingGeocodes: Scalars['Int'];
  /** When the Run's Solves were queued for compute */
  queuedAt?: Maybe<Scalars['DateTime']>;
  /** Run Settings snapshot the Run is solved with */
  settings: CapacityPlanRunSettings;
  /** How many of the Run's Solves are waiting, running, done or failed */
  solveProgress: CapacityPlanSolveProgress;
  /** Created, Queued, Computing, Computed or Failed */
  status: CapacityPlanRunStatus;
  /** Rows read from the uploaded file, header excluded */
  totalDeliveries: Scalars['Int'];
  /** The depot summaries added up; null until the Run is computed */
  totals?: Maybe<CapacityPlanRunTotals>;
  /** Rows that take part in the solve */
  validDeliveries: Scalars['Int'];
  /** Non-fatal remarks: excluded rows, failed Solves, unassigned Stops */
  warnings: Array<Scalars['String']>;
};

export type CapacityPlanRunSettings = {
  __typename?: 'CapacityPlanRunSettings';
  /** Breaks every driver of the Run must take */
  breaks: Array<CapacityPlanBreak>;
  /** Per-driver limit, counted in Deliveries; null means no parcel limit, the Shift Window alone bounds each route */
  capacity?: Maybe<Scalars['Int']>;
  /** Planning Depot latitude; null whenever the Depots come from the file */
  depotLatitude?: Maybe<Scalars['Float']>;
  /** Planning Depot longitude; null whenever the Depots come from the file */
  depotLongitude?: Maybe<Scalars['Float']>;
  /** End of the Shift Window, HH:mm:ss */
  shiftEnd: Scalars['String'];
  /** Start of the Shift Window, HH:mm:ss */
  shiftStart: Scalars['String'];
};

export enum CapacityPlanRunStatus {
  Computed = 'COMPUTED',
  Computing = 'COMPUTING',
  Created = 'CREATED',
  Failed = 'FAILED',
  Queued = 'QUEUED'
}

export type CapacityPlanRunSummary = {
  __typename?: 'CapacityPlanRunSummary';
  /** The Agency the Run belongs to; null on a Network Run, which belongs to the country */
  agencyId?: Maybe<Scalars['UUID']>;
  agencyName?: Maybe<Scalars['String']>;
  computedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  /** Username of the supervisor who uploaded the file */
  createdBy?: Maybe<Scalars['String']>;
  /** Drivers needed; null until the Run is computed */
  driverCount?: Maybe<Scalars['Int']>;
  /** Failure message when the Run is Failed */
  error?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  /** Deliveries that have coordinates */
  geocodedDeliveries: Scalars['Int'];
  id: Scalars['UUID'];
  /** True when the Run has no Agency: readable and computable by headquarters users only */
  isNetworkRun: Scalars['Boolean'];
  /** Free text naming the Run for humans; defaults to the file name */
  label?: Maybe<Scalars['String']>;
  /** Run Settings snapshot the Run is solved with */
  settings: CapacityPlanRunSettings;
  /** How many of the Run's Solves are waiting, running, done or failed */
  solveProgress: CapacityPlanSolveProgress;
  /** Created, Queued, Computing, Computed or Failed */
  status: CapacityPlanRunStatus;
  /** Rows read from the uploaded file, header excluded */
  totalDeliveries: Scalars['Int'];
};

/** The depot summaries added up: the headline answer of the Run */
export type CapacityPlanRunTotals = {
  __typename?: 'CapacityPlanRunTotals';
  deliveries: Scalars['Int'];
  /** Deliveries per driver, rounded to one decimal */
  deliveriesPerDriver: Scalars['Float'];
  /** Planning Depots the Run was fanned out over */
  depots: Scalars['Int'];
  /** Drivers needed across every Planning Depot */
  drivers: Scalars['Int'];
  /** Deliveries carried by the Solves that failed: counted in, but not solved */
  failedDeliveries: Scalars['Int'];
  /** Solves that failed; the Run is Computed with warnings, not Failed */
  failedSolves: Scalars['Int'];
  /** Recipients across all depots; 0 for older runs */
  recipients: Scalars['Int'];
  /** Routed recipients per driver, rounded to one decimal; 0 for older runs */
  recipientsPerDriver: Scalars['Float'];
  /** Recipients at the stops on routes: unassigned stops and failed solves left out; 0 for older runs */
  routedRecipients: Scalars['Int'];
  solves: Scalars['Int'];
  stops: Scalars['Int'];
  unassignedDeliveries: Scalars['Int'];
  unassignedStops: Scalars['Int'];
};

export type CapacityPlanSolve = {
  __typename?: 'CapacityPlanSolve';
  /** 0 when the Planning Depot was not split into Clusters */
  clusterIndex: Scalars['Int'];
  /** Drivers this Solve needs; null until it is computed */
  driverCount?: Maybe<Scalars['Int']>;
  /** Why this Solve failed; null otherwise */
  error?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** One route per driver; empty unless the Solve is computed */
  routes: Array<CapacityPlanRoute>;
  status: CapacityPlanSolveStatus;
  /** Stops the solver could not fit, with a reason each */
  unassigned: Array<CapacityPlanUnassignedStop>;
};

/** Where the Run's Solves stand; all zeros until the Run has been planned */
export type CapacityPlanSolveProgress = {
  __typename?: 'CapacityPlanSolveProgress';
  computed: Scalars['Int'];
  computing: Scalars['Int'];
  /** Solves that failed; retryFailedCapacityPlanSolves puts them back on the queue */
  failed: Scalars['Int'];
  /** Solves waiting for a Worker */
  queued: Scalars['Int'];
  /** Solves the Run was fanned out into, one per Planning Depot or Cluster */
  total: Scalars['Int'];
};

/** Lifecycle of one solver call: PENDING, QUEUED, COMPUTING, COMPUTED or FAILED */
export enum CapacityPlanSolveStatus {
  Computed = 'COMPUTED',
  Computing = 'COMPUTING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Queued = 'QUEUED'
}

export type CapacityPlanUnassignedStop = {
  __typename?: 'CapacityPlanUnassignedStop';
  /** The file's own DeliveryId for each of those Deliveries, in file order */
  deliveryCodes: Array<Scalars['String']>;
  /** Row ids of the Deliveries grouped into this Stop */
  deliveryIds: Array<Scalars['Long']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  /** Why the solver could not assign the Stop */
  reason: Scalars['String'];
  stopId: Scalars['Int'];
};

export type CapacityPlanUserError = Error & {
  __typename?: 'CapacityPlanUserError';
  code: CapacityPlanErrorCode;
  deliveryId?: Maybe<Scalars['Long']>;
  message: Scalars['String'];
  runId?: Maybe<Scalars['UUID']>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

export type ComputeCapacityPlanError = CapacityPlanUserError;

export type ComputeCapacityPlanInput = {
  runId: Scalars['UUID'];
};

export type ComputeCapacityPlanPayload = {
  __typename?: 'ComputeCapacityPlanPayload';
  capacityPlanRun?: Maybe<CapacityPlanRun>;
  errors?: Maybe<Array<ComputeCapacityPlanError>>;
};

export type Courier = {
  __typename?: 'Courier';
  /** Courier Generated Itinerary Metrics */
  CourierGeneratedItineraryMetrics?: Maybe<CourierMetrics>;
  /** Late Refill Metrics */
  LateRefillMetrics?: Maybe<CourierLateRefillMetrics>;
  /** System Generated Itinerary Metrics */
  SystemGeneratedItineraryMetrics?: Maybe<CourierMetrics>;
  /** Real Itinerary Metrics */
  TrafficDataItineraryMetrics?: Maybe<TrafficDataCourierMetrics>;
  /** The courier designed itinerary provider for the courier */
  courierDesignedItineraryProvider?: Maybe<Scalars['String']>;
  /** External courier id */
  courierId: Scalars['Int'];
  /** The daily progress */
  dailyProgresses?: Maybe<DailyProgress>;
  /** The default itinerary provider for the courier */
  defaultItineraryProvider?: Maybe<Scalars['String']>;
  /** Courier statistics */
  deliveryStatistics?: Maybe<Array<DeliveryStatistics>>;
  /** The ETA interval of the courier */
  etaInterval: Scalars['Int'];
  /** The indicative of the courier */
  indicative?: Maybe<Scalars['String']>;
};


export type CourierCourierGeneratedItineraryMetricsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type CourierLateRefillMetricsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type CourierSystemGeneratedItineraryMetricsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type CourierTrafficDataItineraryMetricsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type CourierDailyProgressesArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type CourierDeliveryStatisticsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};

export type CourierFilterInput = {
  activityExceptions?: InputMaybe<ListFilterInputTypeOfActivityExceptionFilterInput>;
  agency?: InputMaybe<AgencyFilterInput>;
  and?: InputMaybe<Array<CourierFilterInput>>;
  courierDesignedItineraryProvider?: InputMaybe<StringOperationFilterInput>;
  courierId?: InputMaybe<IntOperationFilterInput>;
  courierMetrics?: InputMaybe<ListFilterInputTypeOfCourierMetricsFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customSettingsChangeHistory?: InputMaybe<ListFilterInputTypeOfCustomSettingsChangeHistoryFilterInput>;
  dailyProgresses?: InputMaybe<ListFilterInputTypeOfDailyProgressFilterInput>;
  defaultItineraryProvider?: InputMaybe<StringOperationFilterInput>;
  deliveryStatistics?: InputMaybe<ListFilterInputTypeOfDeliveryStatisticsFilterInput>;
  etaInterval?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  indicative?: InputMaybe<StringOperationFilterInput>;
  itineraryEvents?: InputMaybe<ListFilterInputTypeOfItineraryEventFilterInput>;
  itineraryVersions?: InputMaybe<ListFilterInputTypeOfItineraryVersionFilterInput>;
  lateRefillMetrics?: InputMaybe<ListFilterInputTypeOfCourierLateRefillMetricsFilterInput>;
  locationTrips?: InputMaybe<ListFilterInputTypeOfLocationTripFilterInput>;
  modifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
  oohRoutes?: InputMaybe<ListFilterInputTypeOfOohRouteFilterInput>;
  or?: InputMaybe<Array<CourierFilterInput>>;
  trafficDataCourierMetrics?: InputMaybe<ListFilterInputTypeOfTrafficDataCourierMetricsFilterInput>;
};

export enum CourierFiltering {
  AllCouriers = 'ALL_COURIERS',
  CourierWithoutItineraries = 'COURIER_WITHOUT_ITINERARIES',
  CourierWithItineraries = 'COURIER_WITH_ITINERARIES'
}

export type CourierLateRefillMetrics = {
  __typename?: 'CourierLateRefillMetrics';
  /** Combine statistic distance in meters */
  combinedStatisticsDistanceInMeters?: Maybe<Scalars['Long']>;
  /** Combined statistic duration in seconds */
  combinedStatisticsDurationInSeconds?: Maybe<Scalars['Long']>;
  /** Courier design distance in meters */
  courierDesignedDistanceInMeters?: Maybe<Scalars['Long']>;
  /** Courier design distance in seconds */
  courierDesignedDurationInSeconds?: Maybe<Scalars['Long']>;
  /** Date of metrics */
  date: Scalars['DateTime'];
  /** Default itinerary distance in meters */
  defaultItineraryDistanceInMeters?: Maybe<Scalars['Long']>;
  /** Default itinerary duration in seconds */
  defaultItineraryDurationInSeconds?: Maybe<Scalars['Long']>;
};

export type CourierLateRefillMetricsFilterInput = {
  and?: InputMaybe<Array<CourierLateRefillMetricsFilterInput>>;
  combinedStatisticsDistanceInMeters?: InputMaybe<LongOperationFilterInput>;
  combinedStatisticsDurationInSeconds?: InputMaybe<LongOperationFilterInput>;
  courier?: InputMaybe<CourierFilterInput>;
  courierDesignedDistanceInMeters?: InputMaybe<LongOperationFilterInput>;
  courierDesignedDurationInSeconds?: InputMaybe<LongOperationFilterInput>;
  courierId?: InputMaybe<IntOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  defaultItineraryDistanceInMeters?: InputMaybe<LongOperationFilterInput>;
  defaultItineraryDurationInSeconds?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<CourierLateRefillMetricsFilterInput>>;
};

export type CourierMetrics = {
  __typename?: 'CourierMetrics';
  /** Date of metrics */
  date: Scalars['DateTime'];
  /** Distance of the itinerary */
  distanceInMeters?: Maybe<Scalars['Long']>;
  /** Duration of the itinerary */
  durationInSeconds?: Maybe<Scalars['Long']>;
};

export type CourierMetricsFilterInput = {
  and?: InputMaybe<Array<CourierMetricsFilterInput>>;
  courier?: InputMaybe<CourierFilterInput>;
  courierId?: InputMaybe<IntOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  distanceInMeters?: InputMaybe<LongOperationFilterInput>;
  durationInSeconds?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  itineraryVersion?: InputMaybe<ItineraryVersionFilterInput>;
  itineraryVersionId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<CourierMetricsFilterInput>>;
};

export type CourierSettingsMutationInput = {
  courierDesignProvider?: InputMaybe<Scalars['String']>;
  courierId: Scalars['Int'];
  defaultProvider?: InputMaybe<Scalars['String']>;
  etaInterval: Scalars['Int'];
};

export type CourierSettingsPayload = {
  __typename?: 'CourierSettingsPayload';
  courierDesignProvider?: Maybe<Scalars['String']>;
  courierId?: Maybe<Scalars['Int']>;
  defaultProvider?: Maybe<Scalars['String']>;
  etaInterval?: Maybe<Scalars['Int']>;
  indicative?: Maybe<Scalars['String']>;
};

export type CourierTotals = {
  __typename?: 'CourierTotals';
  /** Total C2C discharges from DWH */
  totalC2CDischarges?: Maybe<Scalars['Int']>;
  /** Total deliveries from DWH */
  totalDeliveries?: Maybe<Scalars['Int']>;
  /** Total expired discharges from DWH */
  totalExpired?: Maybe<Scalars['Int']>;
  /** Total First Mile discharges from DWH */
  totalFMDischarges?: Maybe<Scalars['Int']>;
  /** Total return discharges from DWH */
  totalReturns?: Maybe<Scalars['Int']>;
};

export type CustomSettingsChangeHistoryFilterInput = {
  and?: InputMaybe<Array<CustomSettingsChangeHistoryFilterInput>>;
  changeReason?: InputMaybe<CustomSettingsChangeReasonOperationFilterInput>;
  changedAt?: InputMaybe<DateTimeOperationFilterInput>;
  changedBy?: InputMaybe<StringOperationFilterInput>;
  courier?: InputMaybe<CourierFilterInput>;
  courierId?: InputMaybe<IntOperationFilterInput>;
  customSettingsChangeOutboxQueue?: InputMaybe<CustomSettingsChangeOutboxQueueFilterInput>;
  customSettingsChangeOutboxQueueId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  newCourierDesignedItineraryProviderValue?: InputMaybe<StringOperationFilterInput>;
  newDefaultItineraryProviderValue?: InputMaybe<StringOperationFilterInput>;
  newEtaIntervalValue?: InputMaybe<IntOperationFilterInput>;
  oldCourierDesignedItineraryProviderValue?: InputMaybe<StringOperationFilterInput>;
  oldDefaultItineraryProviderValue?: InputMaybe<StringOperationFilterInput>;
  oldEtaIntervalValue?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CustomSettingsChangeHistoryFilterInput>>;
};

export type CustomSettingsChangeOutboxQueueFilterInput = {
  and?: InputMaybe<Array<CustomSettingsChangeOutboxQueueFilterInput>>;
  countryCode?: InputMaybe<StringOperationFilterInput>;
  courierDesignedItineraryProvider?: InputMaybe<StringOperationFilterInput>;
  courierId?: InputMaybe<IntOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  customSettingsChangeHistory?: InputMaybe<CustomSettingsChangeHistoryFilterInput>;
  defaultItineraryProvider?: InputMaybe<StringOperationFilterInput>;
  etaInterval?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<CustomSettingsChangeOutboxQueueFilterInput>>;
  sent?: InputMaybe<BooleanOperationFilterInput>;
  sentTime?: InputMaybe<DateTimeOperationFilterInput>;
};

export enum CustomSettingsChangeReason {
  AgencyCustomSettingsChange = 'AGENCY_CUSTOM_SETTINGS_CHANGE',
  IndividualCustomSettingsChange = 'INDIVIDUAL_CUSTOM_SETTINGS_CHANGE',
  SynchronizationCustomSettingsChange = 'SYNCHRONIZATION_CUSTOM_SETTINGS_CHANGE'
}

export type CustomSettingsChangeReasonOperationFilterInput = {
  eq?: InputMaybe<CustomSettingsChangeReason>;
  in?: InputMaybe<Array<CustomSettingsChangeReason>>;
  neq?: InputMaybe<CustomSettingsChangeReason>;
  nin?: InputMaybe<Array<CustomSettingsChangeReason>>;
};

export type DailyProgress = {
  __typename?: 'DailyProgress';
  /** The total number of cancelled deliveries for the day */
  cancelledDeliveries: Scalars['Int'];
  /** The total number of C2C pickups for the day */
  finishedC2CPickups: Scalars['Int'];
  /** The total number of finished deliveries for the day */
  finishedDeliveries: Scalars['Int'];
  /** The total number of locker visits for the day */
  finishedLockerVisits: Scalars['Int'];
  /** The total number of pickups for the day */
  finishedPickups: Scalars['Int'];
  /** The total number of PUDO visits for the day */
  finishedPudoVisits: Scalars['Int'];
  /** The number of R30 retours for the day */
  r30Retours: Scalars['Int'];
  /** The total number of deliveries for the day */
  totalDeliveries: Scalars['Int'];
};

export type DailyProgressFilterInput = {
  and?: InputMaybe<Array<DailyProgressFilterInput>>;
  cancelledDeliveries?: InputMaybe<IntOperationFilterInput>;
  courier?: InputMaybe<CourierFilterInput>;
  courierId?: InputMaybe<IntOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  finishedC2CPickups?: InputMaybe<IntOperationFilterInput>;
  finishedDeliveries?: InputMaybe<IntOperationFilterInput>;
  finishedLockerVisits?: InputMaybe<IntOperationFilterInput>;
  finishedPickups?: InputMaybe<IntOperationFilterInput>;
  finishedPudoVisits?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<DailyProgressFilterInput>>;
  r30Retours?: InputMaybe<IntOperationFilterInput>;
  totalDeliveries?: InputMaybe<IntOperationFilterInput>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

/** A segment of a collection. */
export type DeliveriesStatisticsCollectionSegment = {
  __typename?: 'DeliveriesStatisticsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<DeliveryStatistics>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type DeliveryStatistics = {
  __typename?: 'DeliveryStatistics';
  /** The Id of the courier */
  courierId?: Maybe<Scalars['Int']>;
  /** The daily progress */
  dailyProgress?: Maybe<DailyProgress>;
  /** The date of the itinerary */
  date?: Maybe<Scalars['Date']>;
  /** Number of deliveries out of order */
  noOfDeliveriesOutOfOrder?: Maybe<Scalars['Int']>;
  /** Number of deliveries past ETA */
  noOfDeliveriesPastEta?: Maybe<Scalars['Int']>;
};

export type DeliveryStatisticsFilterInput = {
  and?: InputMaybe<Array<DeliveryStatisticsFilterInput>>;
  courier?: InputMaybe<CourierFilterInput>;
  courierId?: InputMaybe<IntOperationFilterInput>;
  dailyProgress?: InputMaybe<DailyProgressFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  noOfDeliveriesOutOfOrder?: InputMaybe<IntOperationFilterInput>;
  noOfDeliveriesPastEta?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<DeliveryStatisticsFilterInput>>;
};

export type Error = {
  message: Scalars['String'];
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  ngt?: InputMaybe<Scalars['Float']>;
  ngte?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  nlt?: InputMaybe<Scalars['Float']>;
  nlte?: InputMaybe<Scalars['Float']>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type InternalServerUserError = Error & {
  __typename?: 'InternalServerUserError';
  message: Scalars['String'];
};

export type ItineraryEvent = {
  __typename?: 'ItineraryEvent';
  /** The actual order of the event on the itinerary */
  actualOrder?: Maybe<Scalars['Int']>;
  /** The date and time when event was created */
  actualTime: Scalars['DateTime'];
  /** The address of the delivery */
  address?: Maybe<Scalars['String']>;
  /** The county of the delivery */
  county?: Maybe<Scalars['String']>;
  /** The Id of the courier */
  courierId: Scalars['Int'];
  /** The end ETA on current itinerary */
  etaEndTime?: Maybe<Scalars['DateTime']>;
  /** The start ETA on current itinerary */
  etaStartTime?: Maybe<Scalars['DateTime']>;
  /** The type of the event */
  eventType?: Maybe<ItineraryEventType>;
  /** The Id of the event */
  id: Scalars['UUID'];
  /** The Id of the AWB */
  identifier: Scalars['Long'];
  /** The AWB number */
  identifierDescription?: Maybe<Scalars['String']>;
  /** Is Early delivery flag */
  isEarlyDelivery?: Maybe<Scalars['Boolean']>;
  /** Is location approximated flag */
  isLocationApproximated: Scalars['Boolean'];
  /** Is address manually geocoded flag */
  isManuallyGeocoded: Scalars['Boolean'];
  /** The estimated order of the event on the itinerary */
  itineraryOrder?: Maybe<Scalars['Int']>;
  /** The latitude of the delivery that was affected by a delivery or cancel event */
  latitude?: Maybe<Scalars['Float']>;
  /** The longitude of the delivery that was affected by a delivery or cancel event */
  longitude?: Maybe<Scalars['Float']>;
  /** The AWBs that were picked up */
  pickedUpAwbNumbers?: Maybe<Scalars['String']>;
  /** Pick up point client name */
  pickupPointClientName?: Maybe<Scalars['String']>;
  /** The town of the delivery */
  town?: Maybe<Scalars['String']>;
  /** The village of the delivery */
  village?: Maybe<Scalars['String']>;
  /** Cut Off interval end time */
  visitTimeWindowEnd?: Maybe<Scalars['DateTime']>;
  /** Cut Off interval start time */
  visitTimeWindowStart?: Maybe<Scalars['DateTime']>;
};

export type ItineraryEventFilterInput = {
  actualOrder?: InputMaybe<IntOperationFilterInput>;
  actualTime?: InputMaybe<DateTimeOperationFilterInput>;
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ItineraryEventFilterInput>>;
  county?: InputMaybe<StringOperationFilterInput>;
  courier?: InputMaybe<CourierFilterInput>;
  courierId?: InputMaybe<IntOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  estimatedArrivalTime?: InputMaybe<DateTimeOperationFilterInput>;
  estimatedDepartureTime?: InputMaybe<DateTimeOperationFilterInput>;
  etaEndTime?: InputMaybe<DateTimeOperationFilterInput>;
  etaStartTime?: InputMaybe<DateTimeOperationFilterInput>;
  eventType?: InputMaybe<ItineraryEventTypeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  identifier?: InputMaybe<LongOperationFilterInput>;
  identifierDescription?: InputMaybe<StringOperationFilterInput>;
  isEarlyDelivery?: InputMaybe<BooleanOperationFilterInput>;
  isLocationApproximated?: InputMaybe<BooleanOperationFilterInput>;
  isManuallyGeocoded?: InputMaybe<BooleanOperationFilterInput>;
  isOutOfEtaInterval?: InputMaybe<BooleanOperationFilterInput>;
  itineraryOrder?: InputMaybe<IntOperationFilterInput>;
  itineraryVersionId?: InputMaybe<UuidOperationFilterInput>;
  jobTimeInSeconds?: InputMaybe<IntOperationFilterInput>;
  latitude?: InputMaybe<FloatOperationFilterInput>;
  longitude?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<ItineraryEventFilterInput>>;
  packageType?: InputMaybe<NullableOfPackageTypeOperationFilterInput>;
  pickedUpAwbNumbers?: InputMaybe<StringOperationFilterInput>;
  pickedUpAwbNumbersList?: InputMaybe<ListStringOperationFilterInput>;
  pickupClusterLabel?: InputMaybe<StringOperationFilterInput>;
  pickupPointClientName?: InputMaybe<StringOperationFilterInput>;
  town?: InputMaybe<StringOperationFilterInput>;
  village?: InputMaybe<StringOperationFilterInput>;
  visitTimeWindowEnd?: InputMaybe<DateTimeOperationFilterInput>;
  visitTimeWindowStart?: InputMaybe<DateTimeOperationFilterInput>;
};

export enum ItineraryEventType {
  C2CPickup = 'C2C_PICKUP',
  Cancellation = 'CANCELLATION',
  Delivery = 'DELIVERY',
  LockerVisit = 'LOCKER_VISIT',
  Pickup = 'PICKUP',
  PickPackRetour = 'PICK_PACK_RETOUR',
  PudoVisit = 'PUDO_VISIT',
  StandardRetour = 'STANDARD_RETOUR'
}

export type ItineraryEventTypeOperationFilterInput = {
  eq?: InputMaybe<ItineraryEventType>;
  in?: InputMaybe<Array<ItineraryEventType>>;
  neq?: InputMaybe<ItineraryEventType>;
  nin?: InputMaybe<Array<ItineraryEventType>>;
};

export type ItineraryStop = {
  __typename?: 'ItineraryStop';
  /** The address of the delivery */
  address?: Maybe<Scalars['String']>;
  /** The expected arrival time */
  arrival?: Maybe<Scalars['DateTime']>;
  /** Contains R30 retour addresses */
  containsR30Awbs: Scalars['Boolean'];
  /** The county of the delivery */
  county?: Maybe<Scalars['String']>;
  /** The expected departure time */
  departure?: Maybe<Scalars['DateTime']>;
  /** The Id of the stop */
  id: Scalars['UUID'];
  /** The list of awb ids */
  identifiers?: Maybe<Scalars['String']>;
  /** The AWB numbers or the pick-up point alias */
  identifiersDescriptions?: Maybe<Scalars['String']>;
  /** The type of the stop, delivery or pickup */
  jobType: JobType;
  /** The latitude of the stop */
  latitude?: Maybe<Scalars['Float']>;
  /** The longitude of the stop */
  longitude?: Maybe<Scalars['Float']>;
  /** The start of the delivery interval */
  notificationIntervalStart?: Maybe<Scalars['DateTime']>;
  /** The end of the delivery interval */
  notificationIntervalStop?: Maybe<Scalars['DateTime']>;
  /** The order of the stop */
  order: Scalars['Int'];
  /** The resource type of the stop (Delivery, Pickup, Locker, Pudo, etc.) */
  stopType: StopType;
  /** The town of the delivery */
  town?: Maybe<Scalars['String']>;
  /** The village of the delivery */
  village?: Maybe<Scalars['String']>;
};

export type ItineraryStopFilterInput = {
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ItineraryStopFilterInput>>;
  arrival?: InputMaybe<DateTimeOperationFilterInput>;
  containsR30Awbs?: InputMaybe<BooleanOperationFilterInput>;
  county?: InputMaybe<StringOperationFilterInput>;
  departure?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  identifiers?: InputMaybe<StringOperationFilterInput>;
  identifiersDescriptions?: InputMaybe<StringOperationFilterInput>;
  identifiersDescriptionsList?: InputMaybe<ListStringOperationFilterInput>;
  identifiersList?: InputMaybe<ListLongOperationFilterInput>;
  itineraryVersion?: InputMaybe<ItineraryVersionFilterInput>;
  itineraryVersionId?: InputMaybe<UuidOperationFilterInput>;
  jobTimeInSeconds?: InputMaybe<IntOperationFilterInput>;
  jobType?: InputMaybe<JobTypeOperationFilterInput>;
  latitude?: InputMaybe<FloatOperationFilterInput>;
  longitude?: InputMaybe<FloatOperationFilterInput>;
  notificationIntervalStart?: InputMaybe<DateTimeOperationFilterInput>;
  notificationIntervalStop?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ItineraryStopFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  sendNotificationToCustomer?: InputMaybe<BooleanOperationFilterInput>;
  stopType?: InputMaybe<StopTypeOperationFilterInput>;
  town?: InputMaybe<StringOperationFilterInput>;
  village?: InputMaybe<StringOperationFilterInput>;
};

export type ItineraryVersion = {
  __typename?: 'ItineraryVersion';
  /** Small and normal awb delivery time */
  approximateLocationAdditionalTime?: Maybe<Scalars['Int']>;
  /** The Id of the courier */
  courierId: Scalars['Int'];
  /** The creation date of the itinerary version */
  createdDate: Scalars['DateTime'];
  /** The ending latitude of the itinerary version */
  endLatitude: Scalars['Float'];
  /** The ending longitude of the itinerary version */
  endLongitude: Scalars['Float'];
  /** The Id of the itinerary */
  id: Scalars['UUID'];
  /** Boolean indicating if the itinerary is generated by courier */
  isCourierOrder: Scalars['Boolean'];
  /** Flag indicating if the itinerary is a late refill */
  isLateRefill: Scalars['Boolean'];
  /** The stops of the itinerary version */
  itineraryStops: Array<ItineraryStop>;
  /** The list of itinerary warnings grouped by error code */
  itineraryWarnings: Array<KeyValuePairOfStringAndListOfItineraryWarning>;
  /** Small and normal awb delivery time */
  largeAwbDeliveryTime?: Maybe<Scalars['Int']>;
  /** Additional time required for Out-of-Home (OOH) delivery point interactions including Lockers and PUDO locations */
  oohAdditionalTime?: Maybe<Scalars['Int']>;
  /** Small and normal awb delivery time */
  parkingTime?: Maybe<Scalars['Int']>;
  /** The list of courier pauses in the itinerary version */
  pauseIntervals: Array<ItineraryVersionPauseInterval>;
  /** The itinerary provider */
  provider?: Maybe<Scalars['String']>;
  /** Small and normal awb delivery time */
  smallAndNormalAwbDeliveryTime?: Maybe<Scalars['Int']>;
  /** The starting latitude of the itinerary version */
  startLatitude: Scalars['Float'];
  /** The starting longitude of the itinerary version */
  startLongitude: Scalars['Float'];
  /** Itinerary starting time */
  startingTime: Scalars['DateTime'];
};

export type ItineraryVersionFilterInput = {
  and?: InputMaybe<Array<ItineraryVersionFilterInput>>;
  approximateLocationAdditionalTime?: InputMaybe<IntOperationFilterInput>;
  courier?: InputMaybe<CourierFilterInput>;
  courierId?: InputMaybe<IntOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  endLatitude?: InputMaybe<FloatOperationFilterInput>;
  endLongitude?: InputMaybe<FloatOperationFilterInput>;
  groupedItineraryWarnings?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndItineraryWarningFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isCourierOrder?: InputMaybe<BooleanOperationFilterInput>;
  isLateRefill?: InputMaybe<BooleanOperationFilterInput>;
  itineraryStops?: InputMaybe<ListFilterInputTypeOfItineraryStopFilterInput>;
  itineraryWarnings?: InputMaybe<ListFilterInputTypeOfItineraryWarningFilterInput>;
  largeAwbDeliveryTime?: InputMaybe<IntOperationFilterInput>;
  oohAdditionalTime?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ItineraryVersionFilterInput>>;
  parkingTime?: InputMaybe<IntOperationFilterInput>;
  pauseIntervals?: InputMaybe<ListFilterInputTypeOfItineraryVersionPauseIntervalFilterInput>;
  provider?: InputMaybe<StringOperationFilterInput>;
  smallAndNormalAwbDeliveryTime?: InputMaybe<IntOperationFilterInput>;
  startLatitude?: InputMaybe<FloatOperationFilterInput>;
  startLongitude?: InputMaybe<FloatOperationFilterInput>;
  startingTime?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ItineraryVersionPauseInterval = {
  __typename?: 'ItineraryVersionPauseInterval';
  /** The end time of the itinerary pause interval */
  endTime: Scalars['DateTime'];
  /** The id of the itinerary pause interval */
  id: Scalars['UUID'];
  /** The start time of the itinerary pause interval */
  startTime: Scalars['DateTime'];
};

export type ItineraryVersionPauseIntervalFilterInput = {
  and?: InputMaybe<Array<ItineraryVersionPauseIntervalFilterInput>>;
  endTime?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  itineraryVersion?: InputMaybe<ItineraryVersionFilterInput>;
  itineraryVersionId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ItineraryVersionPauseIntervalFilterInput>>;
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
};

export enum ItineraryVersionReasonType {
  CancelDelivery = 'CANCEL_DELIVERY',
  ComputeCourierDesignItinerary = 'COMPUTE_COURIER_DESIGN_ITINERARY',
  ComputeDefaultItinerary = 'COMPUTE_DEFAULT_ITINERARY',
  EarlyDelivery = 'EARLY_DELIVERY'
}

export type ItineraryWarning = {
  __typename?: 'ItineraryWarning';
  /** The error code of the itinerary warning */
  errorCode?: Maybe<Scalars['String']>;
  /** The error message of the itinerary warning */
  errorMessage?: Maybe<Scalars['String']>;
  /** The Id of the itinerary warning */
  id: Scalars['UUID'];
  /** The list of affected identifiers */
  identifiers?: Maybe<Scalars['String']>;
};

export type ItineraryWarningFilterInput = {
  and?: InputMaybe<Array<ItineraryWarningFilterInput>>;
  errorCode?: InputMaybe<StringOperationFilterInput>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  identifiers?: InputMaybe<StringOperationFilterInput>;
  identifiersList?: InputMaybe<ListLongOperationFilterInput>;
  itineraryVersion?: InputMaybe<ItineraryVersionFilterInput>;
  itineraryVersionId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ItineraryWarningFilterInput>>;
};

export enum JobType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type JobTypeOperationFilterInput = {
  eq?: InputMaybe<JobType>;
  in?: InputMaybe<Array<JobType>>;
  neq?: InputMaybe<JobType>;
  nin?: InputMaybe<Array<JobType>>;
};

export type KeyValuePairOfStringAndItineraryWarningFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndItineraryWarningFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndItineraryWarningFilterInput>>;
  value?: InputMaybe<ItineraryWarningFilterInput>;
};

export type KeyValuePairOfStringAndListOfItineraryWarning = {
  __typename?: 'KeyValuePairOfStringAndListOfItineraryWarning';
  key: Scalars['String'];
  value: Array<ItineraryWarning>;
};

export type ListFilterInputTypeOfActivityExceptionFilterInput = {
  all?: InputMaybe<ActivityExceptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActivityExceptionFilterInput>;
  some?: InputMaybe<ActivityExceptionFilterInput>;
};

export type ListFilterInputTypeOfAgencyFilterInput = {
  all?: InputMaybe<AgencyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AgencyFilterInput>;
  some?: InputMaybe<AgencyFilterInput>;
};

export type ListFilterInputTypeOfAgencyZoneFilterInput = {
  all?: InputMaybe<AgencyZoneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AgencyZoneFilterInput>;
  some?: InputMaybe<AgencyZoneFilterInput>;
};

export type ListFilterInputTypeOfCourierFilterInput = {
  all?: InputMaybe<CourierFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CourierFilterInput>;
  some?: InputMaybe<CourierFilterInput>;
};

export type ListFilterInputTypeOfCourierLateRefillMetricsFilterInput = {
  all?: InputMaybe<CourierLateRefillMetricsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CourierLateRefillMetricsFilterInput>;
  some?: InputMaybe<CourierLateRefillMetricsFilterInput>;
};

export type ListFilterInputTypeOfCourierMetricsFilterInput = {
  all?: InputMaybe<CourierMetricsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CourierMetricsFilterInput>;
  some?: InputMaybe<CourierMetricsFilterInput>;
};

export type ListFilterInputTypeOfCustomSettingsChangeHistoryFilterInput = {
  all?: InputMaybe<CustomSettingsChangeHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomSettingsChangeHistoryFilterInput>;
  some?: InputMaybe<CustomSettingsChangeHistoryFilterInput>;
};

export type ListFilterInputTypeOfDailyProgressFilterInput = {
  all?: InputMaybe<DailyProgressFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DailyProgressFilterInput>;
  some?: InputMaybe<DailyProgressFilterInput>;
};

export type ListFilterInputTypeOfDeliveryStatisticsFilterInput = {
  all?: InputMaybe<DeliveryStatisticsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DeliveryStatisticsFilterInput>;
  some?: InputMaybe<DeliveryStatisticsFilterInput>;
};

export type ListFilterInputTypeOfItineraryEventFilterInput = {
  all?: InputMaybe<ItineraryEventFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ItineraryEventFilterInput>;
  some?: InputMaybe<ItineraryEventFilterInput>;
};

export type ListFilterInputTypeOfItineraryStopFilterInput = {
  all?: InputMaybe<ItineraryStopFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ItineraryStopFilterInput>;
  some?: InputMaybe<ItineraryStopFilterInput>;
};

export type ListFilterInputTypeOfItineraryVersionFilterInput = {
  all?: InputMaybe<ItineraryVersionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ItineraryVersionFilterInput>;
  some?: InputMaybe<ItineraryVersionFilterInput>;
};

export type ListFilterInputTypeOfItineraryVersionPauseIntervalFilterInput = {
  all?: InputMaybe<ItineraryVersionPauseIntervalFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ItineraryVersionPauseIntervalFilterInput>;
  some?: InputMaybe<ItineraryVersionPauseIntervalFilterInput>;
};

export type ListFilterInputTypeOfItineraryWarningFilterInput = {
  all?: InputMaybe<ItineraryWarningFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ItineraryWarningFilterInput>;
  some?: InputMaybe<ItineraryWarningFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndItineraryWarningFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndItineraryWarningFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<KeyValuePairOfStringAndItineraryWarningFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndItineraryWarningFilterInput>;
};

export type ListFilterInputTypeOfLocationTripFilterInput = {
  all?: InputMaybe<LocationTripFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<LocationTripFilterInput>;
  some?: InputMaybe<LocationTripFilterInput>;
};

export type ListFilterInputTypeOfOohPointFilterInput = {
  all?: InputMaybe<OohPointFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OohPointFilterInput>;
  some?: InputMaybe<OohPointFilterInput>;
};

export type ListFilterInputTypeOfOohPointRouteFilterInput = {
  all?: InputMaybe<OohPointRouteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OohPointRouteFilterInput>;
  some?: InputMaybe<OohPointRouteFilterInput>;
};

export type ListFilterInputTypeOfOohPointScheduleFilterInput = {
  all?: InputMaybe<OohPointScheduleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OohPointScheduleFilterInput>;
  some?: InputMaybe<OohPointScheduleFilterInput>;
};

export type ListFilterInputTypeOfOohPointSpecialScheduleFilterInput = {
  all?: InputMaybe<OohPointSpecialScheduleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OohPointSpecialScheduleFilterInput>;
  some?: InputMaybe<OohPointSpecialScheduleFilterInput>;
};

export type ListFilterInputTypeOfOohRouteFilterInput = {
  all?: InputMaybe<OohRouteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OohRouteFilterInput>;
  some?: InputMaybe<OohRouteFilterInput>;
};

export type ListFilterInputTypeOfTrafficDataCourierMetricsFilterInput = {
  all?: InputMaybe<TrafficDataCourierMetricsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TrafficDataCourierMetricsFilterInput>;
  some?: InputMaybe<TrafficDataCourierMetricsFilterInput>;
};

export type ListLongOperationFilterInput = {
  all?: InputMaybe<LongOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<LongOperationFilterInput>;
  some?: InputMaybe<LongOperationFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type LocationTripFilterInput = {
  and?: InputMaybe<Array<LocationTripFilterInput>>;
  courier?: InputMaybe<CourierFilterInput>;
  courierId?: InputMaybe<UuidOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  locationDepartureTime?: InputMaybe<DateTimeOperationFilterInput>;
  locationReturnTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<LocationTripFilterInput>>;
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']>;
  gt?: InputMaybe<Scalars['Long']>;
  gte?: InputMaybe<Scalars['Long']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  lt?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
  neq?: InputMaybe<Scalars['Long']>;
  ngt?: InputMaybe<Scalars['Long']>;
  ngte?: InputMaybe<Scalars['Long']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  nlt?: InputMaybe<Scalars['Long']>;
  nlte?: InputMaybe<Scalars['Long']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  UpdateAgencySettings: UpdateAgencySettingsPayload;
  UpdateCourierSettings: UpdateCourierSettingsPayload;
  /** Plans the Run into one Solve per Planning Depot or Cluster and queues them. Returns the Run in Queued with solveProgress.total. */
  computeCapacityPlan: ComputeCapacityPlanPayload;
  /** Sends every never-requested or Failed Delivery of a Run into the Address Processing Flow. */
  requestCapacityPlanGeocoding: RequestCapacityPlanGeocodingPayload;
  /** Puts only the failed Solves of a Run back on the compute queue; the computed ones keep their routes. */
  retryFailedCapacityPlanSolves: RetryFailedCapacityPlanSolvesPayload;
  /** Corrects the address columns of one invalid or failed-geocode Delivery and re-checks them. A row without coordinates goes back to Pending. */
  setCapacityPlanDeliveryAddress: SetCapacityPlanDeliveryAddressPayload;
  /** Overwrites the coordinates of one Delivery by hand and marks it Manual. */
  setCapacityPlanDeliveryCoordinates: SetCapacityPlanDeliveryCoordinatesPayload;
  /** Replaces the Run Settings snapshot and the Label. Refused while Queued or Computing. */
  updateCapacityPlanRunSettings: UpdateCapacityPlanRunSettingsPayload;
};


export type MutationUpdateAgencySettingsArgs = {
  input: UpdateAgencySettingsInput;
};


export type MutationUpdateCourierSettingsArgs = {
  input: UpdateCourierSettingsInput;
};


export type MutationComputeCapacityPlanArgs = {
  input: ComputeCapacityPlanInput;
};


export type MutationRequestCapacityPlanGeocodingArgs = {
  input: RequestCapacityPlanGeocodingInput;
};


export type MutationRetryFailedCapacityPlanSolvesArgs = {
  input: RetryFailedCapacityPlanSolvesInput;
};


export type MutationSetCapacityPlanDeliveryAddressArgs = {
  input: SetCapacityPlanDeliveryAddressInput;
};


export type MutationSetCapacityPlanDeliveryCoordinatesArgs = {
  input: SetCapacityPlanDeliveryCoordinatesInput;
};


export type MutationUpdateCapacityPlanRunSettingsArgs = {
  input: UpdateCapacityPlanRunSettingsInput;
};

export type NullableOfPackageTypeOperationFilterInput = {
  eq?: InputMaybe<PackageType>;
  in?: InputMaybe<Array<InputMaybe<PackageType>>>;
  neq?: InputMaybe<PackageType>;
  nin?: InputMaybe<Array<InputMaybe<PackageType>>>;
};

export enum OohCategory {
  Locker = 'LOCKER',
  Pudo = 'PUDO'
}

export type OohCategoryOperationFilterInput = {
  eq?: InputMaybe<OohCategory>;
  in?: InputMaybe<Array<OohCategory>>;
  neq?: InputMaybe<OohCategory>;
  nin?: InputMaybe<Array<OohCategory>>;
};

export type OohCourierTrip = {
  __typename?: 'OohCourierTrip';
  /** The courier warehouse visits */
  agencyCourierVisits: Array<AgencyCourierVisit>;
  /** External courier id */
  courierId: Scalars['Int'];
  /** Courier totals aggregated from DWH data */
  courierTotals?: Maybe<CourierTotals>;
  /** The indicative of the courier */
  indicative: Scalars['String'];
  /** The trips for the courier */
  locationTrips: Array<OohTrip>;
};


export type OohCourierTripAgencyCourierVisitsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type OohCourierTripCourierTotalsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type OohCourierTripLocationTripsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};

export type OohCourierVisit = {
  __typename?: 'OohCourierVisit';
  /** The courier indicative */
  courierIndicative?: Maybe<Scalars['String']>;
  /** The Id of the OOH point */
  oohId?: Maybe<Scalars['Int']>;
  /** The Name of the OOH point */
  oohPoint?: Maybe<OohPoint>;
  /** The number of parcels loaded in the OOH point */
  visitCharges?: Maybe<Scalars['Short']>;
  /** The number of C2C discharges */
  visitDischargesC2C?: Maybe<Scalars['Short']>;
  /** The number of expired parcels discharges */
  visitDischargesExpired?: Maybe<Scalars['Short']>;
  /** The number of First Mile discharges */
  visitDischargesFirstMile?: Maybe<Scalars['Short']>;
  /** The number of returns discharges */
  visitDischargesReturn?: Maybe<Scalars['Short']>;
  /** The visit end time */
  visitEndTime?: Maybe<Scalars['DateTime']>;
  /** The visit start time */
  visitStartTime?: Maybe<Scalars['DateTime']>;
};

export type OohPoint = {
  __typename?: 'OohPoint';
  /** The capacity of the ooh point */
  capacity: Scalars['Int'];
  /** The Id of the ooh point */
  id: Scalars['UUID'];
  /** The latitude of the ooh point */
  latitude: Scalars['Float'];
  /** The longitude of the ooh point */
  longitude: Scalars['Float'];
  /** The name of the ooh point */
  name?: Maybe<Scalars['String']>;
  /** The type of the ooh point */
  oohType?: Maybe<Scalars['String']>;
  /** The schedules of the ooh point */
  schedules?: Maybe<Array<OohPointSchedule>>;
  /** The special schedules of the ooh point */
  specialSchedules?: Maybe<Array<OohPointSpecialSchedule>>;
};

export type OohPointFilterInput = {
  and?: InputMaybe<Array<OohPointFilterInput>>;
  capacity?: InputMaybe<IntOperationFilterInput>;
  category?: InputMaybe<OohCategoryOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  externalId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  latitude?: InputMaybe<FloatOperationFilterInput>;
  longitude?: InputMaybe<FloatOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  oohRoutes?: InputMaybe<ListFilterInputTypeOfOohRouteFilterInput>;
  oohType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OohPointFilterInput>>;
  schedules?: InputMaybe<ListFilterInputTypeOfOohPointScheduleFilterInput>;
  specialSchedules?: InputMaybe<ListFilterInputTypeOfOohPointSpecialScheduleFilterInput>;
  status?: InputMaybe<OohPointStatusOperationFilterInput>;
};

export type OohPointRouteFilterInput = {
  and?: InputMaybe<Array<OohPointRouteFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  oohPoint?: InputMaybe<OohPointFilterInput>;
  oohRoute?: InputMaybe<OohRouteFilterInput>;
  or?: InputMaybe<Array<OohPointRouteFilterInput>>;
};

export type OohPointSchedule = {
  __typename?: 'OohPointSchedule';
  /** The closing hours of the schedule */
  closingTime?: Maybe<Scalars['String']>;
  /** The day of week of the schedule */
  dayOfWeek: Scalars['Int'];
  /** The Id of the schedule */
  id: Scalars['UUID'];
  /** The opening hours of the schedule */
  openingTime?: Maybe<Scalars['String']>;
};

export type OohPointScheduleFilterInput = {
  and?: InputMaybe<Array<OohPointScheduleFilterInput>>;
  closingTime?: InputMaybe<TimeSpanOperationFilterInput>;
  dayOfWeek?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  oohPoint?: InputMaybe<OohPointFilterInput>;
  oohPointId?: InputMaybe<UuidOperationFilterInput>;
  openingTime?: InputMaybe<TimeSpanOperationFilterInput>;
  or?: InputMaybe<Array<OohPointScheduleFilterInput>>;
};

export type OohPointSpecialSchedule = {
  __typename?: 'OohPointSpecialSchedule';
  /** Flag if it is bank holiday */
  bankHoliday: Scalars['Boolean'];
  /** The closing hours of the schedule */
  closingTime?: Maybe<Scalars['String']>;
  /** The day of month of the schedule */
  dayOfMonth: Scalars['Int'];
  /** The Id of the schedule */
  id: Scalars['UUID'];
  /** The month of the schedule */
  month: Scalars['Int'];
  /** The opening hours of the schedule */
  openingTime?: Maybe<Scalars['String']>;
};

export type OohPointSpecialScheduleFilterInput = {
  and?: InputMaybe<Array<OohPointSpecialScheduleFilterInput>>;
  bankHoliday?: InputMaybe<BooleanOperationFilterInput>;
  closingTime?: InputMaybe<TimeSpanOperationFilterInput>;
  dayOfMonth?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  month?: InputMaybe<IntOperationFilterInput>;
  oohPoint?: InputMaybe<OohPointFilterInput>;
  oohPointId?: InputMaybe<UuidOperationFilterInput>;
  openingTime?: InputMaybe<TimeSpanOperationFilterInput>;
  or?: InputMaybe<Array<OohPointSpecialScheduleFilterInput>>;
};

export enum OohPointStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type OohPointStatusOperationFilterInput = {
  eq?: InputMaybe<OohPointStatus>;
  in?: InputMaybe<Array<OohPointStatus>>;
  neq?: InputMaybe<OohPointStatus>;
  nin?: InputMaybe<Array<OohPointStatus>>;
};

export type OohRoute = {
  __typename?: 'OohRoute';
  /** The couriers of the ooh route */
  couriers: Array<Courier>;
  /** The Id of the ooh route */
  id: Scalars['UUID'];
  /** The Ooh Points of the route */
  oohPoints: Array<OohPoint>;
  /** The status of the ooh route */
  oohRouteStatus: OohRouteStatus;
  /** The Name of the ooh route */
  routeName?: Maybe<Scalars['String']>;
};

export type OohRouteFilterInput = {
  agencies?: InputMaybe<ListFilterInputTypeOfAgencyFilterInput>;
  and?: InputMaybe<Array<OohRouteFilterInput>>;
  couriers?: InputMaybe<ListFilterInputTypeOfCourierFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  externalId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  oohPointRoutes?: InputMaybe<ListFilterInputTypeOfOohPointRouteFilterInput>;
  oohPoints?: InputMaybe<ListFilterInputTypeOfOohPointFilterInput>;
  oohRouteStatus?: InputMaybe<OohRouteStatusOperationFilterInput>;
  or?: InputMaybe<Array<OohRouteFilterInput>>;
  routeName?: InputMaybe<StringOperationFilterInput>;
  routeValidityEndDate?: InputMaybe<DateTimeOperationFilterInput>;
  routeValidityStartDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export enum OohRouteStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type OohRouteStatusOperationFilterInput = {
  eq?: InputMaybe<OohRouteStatus>;
  in?: InputMaybe<Array<OohRouteStatus>>;
  neq?: InputMaybe<OohRouteStatus>;
  nin?: InputMaybe<Array<OohRouteStatus>>;
};

export type OohTrip = {
  __typename?: 'OohTrip';
  /** List of individual visits to OOH point */
  oohCourierVisits: Array<OohCourierVisit>;
  /** The trip departure time from the warehouse */
  warehouseDepartureTime: Scalars['DateTime'];
  /** The trip return time to the warehouse */
  warehouseReturnTime: Scalars['DateTime'];
};


export type OohTripOohCourierVisitsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};

export enum PackageType {
  Large = 'LARGE',
  Normal = 'NORMAL',
  Small = 'SMALL'
}

export type ProviderInfo = {
  __typename?: 'ProviderInfo';
  /** The provider description */
  providerDescription: Scalars['String'];
  /** The provider name */
  providerName?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  /** Returns the number of re-computations for each day for each courier */
  ActivityExceptions?: Maybe<ActivityExceptionsCollectionSegment>;
  /** Returns a list of agencies */
  Agencies: Array<Agency>;
  /** Agency settings */
  AgencySettings: AgencySettings;
  /** Returns a list of agency zones using GeoJson format */
  AgencyZones: Array<ZoneGeometryDto>;
  /** Returns a list of all courier ids in the system */
  AllCouriers: Array<Courier>;
  /** Returns a list of courier design itinerary providers */
  CourierDesignItineraryProviders: Array<ProviderInfo>;
  /** Agency couriers */
  CouriersByAgency: Array<Courier>;
  /** Returns a list of courier ids for which we have itineraries */
  CouriersWithItineraries: Array<Courier>;
  /** Returns a list of courier ids for which we have itineraries in a specific time period */
  CouriersWithItinerariesOverPeriod: Array<Courier>;
  /** Returns the number of events for each type: Deliveries, Cancellations, Retours, Pickups, Locker Visits and PUDO Visits */
  DailyProgressByCourierIdAndDate?: Maybe<DailyProgress>;
  /** Returns a list of default itinerary providers */
  DefaultItineraryProviders: Array<ProviderInfo>;
  /** Returns a list with out of order/late deliveries count for each day/itinerary */
  DeliveriesStatistics?: Maybe<DeliveriesStatisticsCollectionSegment>;
  /** Returns the number of out of order/late deliveries count for a courierId-date pair */
  DeliveriesStatisticsByCourierIdAndDate?: Maybe<DeliveryStatistics>;
  /** Returns a list of itinerary events */
  Events: Array<ItineraryEvent>;
  /** Returns a list of itineraries versions */
  Itineraries: Array<ItineraryVersion>;
  /** Returns a list of ooh trips for a list of couriers and date */
  OohCourierTrips: Array<OohCourierTrip>;
  /** Returns a list of ooh routes for an agency */
  OohRoutes: Array<OohRoute>;
  /** Returns a list of courier visits at specified OOH point */
  OohVisits: Array<OohCourierVisit>;
  /** One page of a Run's Deliveries, narrowed by the filter. */
  capacityPlanDeliveries: CapacityPlanDeliveriesPage;
  /** The problems of a Run's Deliveries grouped by reason; reason texts and counts only. */
  capacityPlanDeliveryIssues: Array<CapacityPlanDeliveryIssue>;
  /** The Solves of one Planning Depot with their routes, geometry and unassigned Stops. The heavy query of the feature: ask for one depot at a time. */
  capacityPlanRoutes: CapacityPlanDepotRoutes;
  /** One Run with its Run Settings and, once computed, its depot summaries and totals. */
  capacityPlanRun: CapacityPlanRun;
  /** The capacity planning Runs of one Agency, newest first. A null agencyId lists the Network Runs of the country, which headquarters users alone may read. Depot summaries are not included. */
  capacityPlanRuns: Array<CapacityPlanRunSummary>;
};


export type QueryActivityExceptionsArgs = {
  courierIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  endDate?: InputMaybe<Scalars['Date']>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAgencySettingsArgs = {
  agencyId?: InputMaybe<Scalars['ID']>;
};


export type QueryAgencyZonesArgs = {
  agencyId?: InputMaybe<Scalars['ID']>;
};


export type QueryCouriersByAgencyArgs = {
  agencyId?: InputMaybe<Scalars['ID']>;
  courierFiltering?: InputMaybe<CourierFiltering>;
  date?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<CourierFilterInput>;
};


export type QueryCouriersWithItinerariesArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type QueryCouriersWithItinerariesOverPeriodArgs = {
  agencyId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type QueryDailyProgressByCourierIdAndDateArgs = {
  courierId?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['Date']>;
};


export type QueryDeliveriesStatisticsArgs = {
  courierIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  endDate?: InputMaybe<Scalars['Date']>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDeliveriesStatisticsByCourierIdAndDateArgs = {
  courierId?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['Date']>;
};


export type QueryEventsArgs = {
  itineraryVersionId?: InputMaybe<Scalars['ID']>;
};


export type QueryItinerariesArgs = {
  courierId?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['Date']>;
};


export type QueryOohCourierTripsArgs = {
  routeId?: InputMaybe<Scalars['ID']>;
};


export type QueryOohRoutesArgs = {
  agencyId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
};


export type QueryOohVisitsArgs = {
  date?: InputMaybe<Scalars['Date']>;
  oohId?: InputMaybe<Scalars['ID']>;
};


export type QueryCapacityPlanDeliveriesArgs = {
  filter?: CapacityPlanDeliveryFilter;
  page?: Scalars['Int'];
  pageSize?: Scalars['Int'];
  runId: Scalars['ID'];
};


export type QueryCapacityPlanDeliveryIssuesArgs = {
  runId: Scalars['ID'];
};


export type QueryCapacityPlanRoutesArgs = {
  depotIndex: Scalars['Int'];
  runId: Scalars['ID'];
};


export type QueryCapacityPlanRunArgs = {
  id: Scalars['ID'];
};


export type QueryCapacityPlanRunsArgs = {
  agencyId?: InputMaybe<Scalars['ID']>;
};

export type RequestCapacityPlanGeocodingError = CapacityPlanUserError;

export type RequestCapacityPlanGeocodingInput = {
  runId: Scalars['UUID'];
};

export type RequestCapacityPlanGeocodingPayload = {
  __typename?: 'RequestCapacityPlanGeocodingPayload';
  capacityPlanGeocoding?: Maybe<CapacityPlanGeocoding>;
  errors?: Maybe<Array<RequestCapacityPlanGeocodingError>>;
};

export type RetryFailedCapacityPlanSolvesError = CapacityPlanUserError;

export type RetryFailedCapacityPlanSolvesInput = {
  runId: Scalars['UUID'];
};

export type RetryFailedCapacityPlanSolvesPayload = {
  __typename?: 'RetryFailedCapacityPlanSolvesPayload';
  capacityPlanRun?: Maybe<CapacityPlanRun>;
  errors?: Maybe<Array<RetryFailedCapacityPlanSolvesError>>;
};

export type RunSettingsInput = {
  breaks: Array<BreakDefinitionInput>;
  capacity?: InputMaybe<Scalars['Int']>;
  depotLatitude?: InputMaybe<Scalars['Float']>;
  depotLongitude?: InputMaybe<Scalars['Float']>;
  label?: InputMaybe<Scalars['String']>;
  shiftEnd?: InputMaybe<Scalars['String']>;
  shiftStart?: InputMaybe<Scalars['String']>;
};

export type SetCapacityPlanDeliveryAddressError = CapacityPlanUserError;

export type SetCapacityPlanDeliveryAddressInput = {
  address?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  deliveryId: Scalars['Long'];
  runId: Scalars['UUID'];
  town?: InputMaybe<Scalars['String']>;
  village?: InputMaybe<Scalars['String']>;
};

export type SetCapacityPlanDeliveryAddressPayload = {
  __typename?: 'SetCapacityPlanDeliveryAddressPayload';
  capacityPlanDeliveryAddressPayload?: Maybe<CapacityPlanDeliveryAddressPayload>;
  errors?: Maybe<Array<SetCapacityPlanDeliveryAddressError>>;
};

export type SetCapacityPlanDeliveryCoordinatesError = CapacityPlanUserError;

export type SetCapacityPlanDeliveryCoordinatesInput = {
  deliveryId: Scalars['Long'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  runId: Scalars['UUID'];
};

export type SetCapacityPlanDeliveryCoordinatesPayload = {
  __typename?: 'SetCapacityPlanDeliveryCoordinatesPayload';
  capacityPlanDeliveryCoordinatesPayload?: Maybe<CapacityPlanDeliveryCoordinatesPayload>;
  errors?: Maybe<Array<SetCapacityPlanDeliveryCoordinatesError>>;
};

export enum StopType {
  Delivery = 'DELIVERY',
  Locker = 'LOCKER',
  Pickup = 'PICKUP',
  Pudo = 'PUDO'
}

export type StopTypeOperationFilterInput = {
  eq?: InputMaybe<StopType>;
  in?: InputMaybe<Array<StopType>>;
  neq?: InputMaybe<StopType>;
  nin?: InputMaybe<Array<StopType>>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type TimeSpanOperationFilterInput = {
  eq?: InputMaybe<Scalars['TimeSpan']>;
  gt?: InputMaybe<Scalars['TimeSpan']>;
  gte?: InputMaybe<Scalars['TimeSpan']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']>>>;
  lt?: InputMaybe<Scalars['TimeSpan']>;
  lte?: InputMaybe<Scalars['TimeSpan']>;
  neq?: InputMaybe<Scalars['TimeSpan']>;
  ngt?: InputMaybe<Scalars['TimeSpan']>;
  ngte?: InputMaybe<Scalars['TimeSpan']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']>>>;
  nlt?: InputMaybe<Scalars['TimeSpan']>;
  nlte?: InputMaybe<Scalars['TimeSpan']>;
};

export type TrafficDataCourierMetrics = {
  __typename?: 'TrafficDataCourierMetrics';
  /** Id of the courier */
  courierId?: Maybe<Scalars['Int']>;
  /** Date of metrics */
  date: Scalars['DateTime'];
  /** Distance of the itinerary */
  distanceInMeters?: Maybe<Scalars['Long']>;
  /** Duration of the itinerary */
  durationInSeconds?: Maybe<Scalars['Long']>;
};

export type TrafficDataCourierMetricsFilterInput = {
  and?: InputMaybe<Array<TrafficDataCourierMetricsFilterInput>>;
  courier?: InputMaybe<CourierFilterInput>;
  courierId?: InputMaybe<IntOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  distanceInMeters?: InputMaybe<FloatOperationFilterInput>;
  durationInSeconds?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<TrafficDataCourierMetricsFilterInput>>;
};

export type UnknownAgencyUserError = Error & {
  __typename?: 'UnknownAgencyUserError';
  agencyId: Scalars['UUID'];
  message: Scalars['String'];
};

export type UnknownCourierUserError = Error & {
  __typename?: 'UnknownCourierUserError';
  courierId: Scalars['Int'];
  message: Scalars['String'];
};

export type UpdateAgencySettingsError = InternalServerUserError | UnknownAgencyUserError | UserError | ValidationUserError;

export type UpdateAgencySettingsInput = {
  agencySettingsMutationInput: AgencySettingsMutationInput;
};

export type UpdateAgencySettingsPayload = {
  __typename?: 'UpdateAgencySettingsPayload';
  agencySettingsPayload?: Maybe<AgencySettingsPayload>;
  errors?: Maybe<Array<UpdateAgencySettingsError>>;
};

export type UpdateCapacityPlanRunSettingsError = CapacityPlanUserError | ValidationUserError;

export type UpdateCapacityPlanRunSettingsInput = {
  runId: Scalars['UUID'];
  settings: RunSettingsInput;
};

export type UpdateCapacityPlanRunSettingsPayload = {
  __typename?: 'UpdateCapacityPlanRunSettingsPayload';
  capacityPlanRun?: Maybe<CapacityPlanRun>;
  errors?: Maybe<Array<UpdateCapacityPlanRunSettingsError>>;
};

export type UpdateCourierSettingsError = InternalServerUserError | UnknownCourierUserError | UserError | ValidationUserError;

export type UpdateCourierSettingsInput = {
  courierSettingsMutationInput: CourierSettingsMutationInput;
};

export type UpdateCourierSettingsPayload = {
  __typename?: 'UpdateCourierSettingsPayload';
  courierSettingsPayload?: Maybe<CourierSettingsPayload>;
  errors?: Maybe<Array<UpdateCourierSettingsError>>;
};

export type UserError = Error & {
  __typename?: 'UserError';
  message: Scalars['String'];
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

export type ValidationUserError = Error & {
  __typename?: 'ValidationUserError';
  message: Scalars['String'];
};

export type ZoneGeometryDto = {
  __typename?: 'ZoneGeometryDto';
  /** GeoJson representation of the zone shape */
  polygonsGeoJson: Scalars['String'];
  /** The zone code name */
  zoneCode: Scalars['String'];
};
